import React, { useState } from "react";
import { useDispatch } from "react-redux";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import { useForm, FormProvider } from "react-hook-form";
import {
  Select,
  MenuItem,
  FormControl,
  FormHelperText,
  TextField,
} from "@mui/material";
import { toast } from "react-toastify";
import { AttachApplicantToCadreLevel } from "../../../../../utils/redux/HR/HRSlice";

export const AttachToCarde = ({
  isOpen,
  onClose,
  modalAction,
  selectedPayrollId,
  refresh,
  setRefresh,
  cadre_position,
}) => {
  const formMethods = useForm({ mode: "all" });
  const dispatch = useDispatch();
  const [selectedCadreId, setSelectedCadreId] = useState([]);

  const {
    handleSubmit,
    register,
    setValue,
    formState: { isValid, errors },
  } = formMethods;

  if (!isOpen) return null;

  const submit = async (data) => {
    console.log("Data:", { data, modalAction, selectedPayrollId });

    const payloadForAttach = {
      applicantId: selectedPayrollId?.id,
      cadreId: data.CadreGradeId,
      cadreLevelId: data.CadreLevelId,
      effectiveDate: data.effectiveDate,
    };

    try {
      const response = await dispatch(
        AttachApplicantToCadreLevel(payloadForAttach)
      );
      if (response?.payload?.successful) {
        setRefresh(!refresh);
        onClose();
        toast.success(response?.payload?.statusMessage);
      } else {
        toast.error(response?.payload?.statusMessage);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <div
      className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center"
      onClick={onClose}
    >
      <div
        className="relative mx-auto p-5 border w-[400px] shadow-lg rounded-md bg-white"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-lg font-semibold text-gray-900 mb-4">
          Attach to Cadre and Level
        </h2>
        <FormProvider {...formMethods}>
          <form onSubmit={handleSubmit(submit)}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "20px",
              }}
            >
              {/* Cadre Grade */}
              <div style={{ margin: "20px 0px" }}>
                <label htmlFor="CadreGradeId">
                  Cadre <sup style={{ color: "red" }}>*</sup>
                </label>
                <FormControl fullWidth>
                  <Select
                    {...register("CadreGradeId", {
                      required: "Cadre is required",
                    })}
                    id="CadreGradeId"
                    defaultValue=""
                    onChange={(e) => {
                      const selectedValue = e.target.value;
                      setValue("CadreGradeId", selectedValue); // Update value in react-hook-form
                      const isFound = cadre_position?.result?.find(
                        (x) => +selectedValue === x?.id
                      );
                      setSelectedCadreId(isFound?.cadreLevels || []);
                    }}
                    error={!!errors.CadreGradeId}
                  >
                    {cadre_position?.result?.map((x) => (
                      <MenuItem key={x.id} value={x.id}>
                        {x.title}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>
                    {errors.CadreGradeId?.message}
                  </FormHelperText>
                </FormControl>
              </div>

              {/* Cadre Level */}
              <div style={{ margin: "20px 0px" }}>
                <label htmlFor="CadreLevelId">
                  Level <sup style={{ color: "red" }}>*</sup>
                </label>
                <FormControl fullWidth>
                  <Select
                    {...register("CadreLevelId", {
                      required: "Level is required",
                    })}
                    id="CadreLevelId"
                    defaultValue=""
                    error={!!errors.CadreLevelId}
                  >
                    {selectedCadreId?.map((x) => (
                      <MenuItem key={x.id} value={x.id}>
                        {x.levelName}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>
                    {errors.CadreLevelId?.message}
                  </FormHelperText>
                </FormControl>
              </div>
            </div>

            {/* First Name */}
            <div style={{ margin: "20px 0px" }}>
              <label htmlFor="effectiveDate">
                Effective Date <sup style={{ color: "red" }}>*</sup>
              </label>
              <TextField
                {...register("effectiveDate", {
                  required: "First Name is required",
                })}
                id="effectiveDate"
                name="effectiveDate"
                fullWidth
                error={!!errors.effectiveDate}
                helperText={errors.effectiveDate?.message}
                type="date"
              />
            </div>

            {/* Buttons */}
            <div className={DashboardStyle.button_cage}>
              <button
                type="button"
                onClick={onClose}
                className="px-6 py-2 bg-gray-100 text-gray-800 border border-gray-300 rounded-md"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={!isValid}
                className="px-6 py-2 bg-green-600 text-white rounded-md"
              >
                Submit
              </button>
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};
